import { request, requestBlob } from '../../Common/api/client';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

/**
 * (전체 약국 마스터) GET /api/admin/pharmacy - 현재는 약국관리 목록에 사용하지 않음
 */
export async function getAdminPharmacies(params = {}) {
  return request({ method: 'GET', url: '/api/admin/pharmacy', params });
}

/**
 * (가맹점/영업자 등록된 약국) GET /api/admin/pharmacy/registered
 * @param {object} params - q, status, terminalId, page, limit, cpId 등
 */
export async function getAdminRegisteredPharmacies(params = {}) {
  return request({ method: 'GET', url: '/api/admin/pharmacy/registered', params });
}

/**
 * GET /api/admin/pharmacy/sync-logs - 동기화 이력
 * @param {object|number} opts - { limit } 또는 limit 숫자
 */
export async function getAdminPharmacySyncLogs(opts = {}) {
  const params = typeof opts === 'number' ? { limit: opts } : opts;
  return request({ method: 'GET', url: '/api/admin/pharmacy/sync-logs', params });
}

/**
 * GET /api/admin/pharmacy/excel - 전체 약국 마스터 엑셀 다운로드
 * 서버가 JSON 형태로 pharmacies 배열을 내려주므로, 프론트에서 XLSX로 엑셀 생성
 * @param {object} params - q, status 등 필터 (cpId 필요 없음)
 */
export async function downloadAdminPharmacyExcel(params = {}) {
  const data = await request({
    method: 'GET',
    url: '/api/admin/pharmacy/excel',
    params,
  });

  const list = data?.pharmacies ?? data?.rows ?? data?.list ?? data ?? [];
  if (!Array.isArray(list) || list.length === 0) {
    throw new Error('다운로드할 약국 데이터가 없습니다.');
  }

  // 엑셀에 넣을 컬럼 매핑 (필요시 조정 가능)
  const rows = list.map((p) => ({
    '약국ID': p.id,
    '기관코드': p.institution_code,
    '요양기관번호': p.ykiho,
    '약국명': p.name,
    '전화번호': p.phone,
    '주소': p.address,
    '우편번호': p.post_no,
    '시도': p.sido_nm,
    '시군구': p.sggu_nm,
    '읍면동': p.endong_nm,
    '업종코드': p.cl_cd,
    '업종명': p.cl_cd_nm,
    '개설일자': p.estb_dd,
    '상태': p.status,
    '소스': p.source,
    '최종동기화일시': p.last_synced_at,
  }));

  const sheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, '전체약국목록');

  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], {
    type:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });

  const name = `약국목록_${new Date().toISOString().slice(0, 10)}.xlsx`;
  saveAs(blob, name);
}
